<script>
import contactForm from './contact-form.vue';

export default {
    name: 'contactSection',

    components: {
        contactForm
    }
};
</script>

<template>

    <section
        id="contact"
        class="contact"
    >

        <div class="container">

            <div class="contact__content">

                <div class="contact__intro">

                    <span class="contact__subtitle">
                        {{ 'contact_section_global' | staticContentAlt }}
                    </span>

                    <h2 class="contact__title">
                        {{ 'contact_section_global' | staticTitle }}
                    </h2>

                    <p class="contact__text">
                        {{ 'contact_section_global' | staticContent }}
                    </p>

                    <div class="contact__details">

                        <div class="contact__detail">

                            <span class="contact__detail-label">
                                EMAIL
                            </span>

                            <a
                                :href="'contact_email' | staticContent"
                            >
                                {{ 'contact_email' | staticTitle }}
                            </a>

                        </div>

                        <div class="contact__detail">

                            <span class="contact__detail-label">
                                PHONE
                            </span>

                            <a
                                :href="'contact_phone' | staticContent"
                            >
                                {{ 'contact_phone' | staticTitle }}
                            </a>

                        </div>

                        <div class="contact__detail">

                            <span class="contact__detail-label">
                                LOCATION
                            </span>

                            <p class="contact__location">
                                {{ 'contact_location' | staticContent }}
                            </p>

                        </div>

                    </div>

                </div>

                <div class="contact__form-wrapper">

                    <contact-form />

                </div>

            </div>

        </div>

    </section>

</template>

<style lang="scss" scoped>
.contact {
    padding: 90px 20px 100px;

    background: var(--background);

    &__content {
        display: flex;
        flex-direction: column;

        gap: 60px;
    }

    &__intro {
        max-width: 550px;
    }

    &__subtitle {
        display: block;

        margin-bottom: 18px;

        font-size: .95rem;
        font-weight: 600;

        letter-spacing: 2px;

        color: var(--primary);

        text-transform: uppercase;
    }

    &__title {
        margin-bottom: 20px;

        font-family: 'Cormorant Garamond', serif;

        font-size: 2.7rem;
        font-weight: 500;

        line-height: 1.05;

        color: var(--text);
    }

    &__text {
        max-width: 500px;

        margin-bottom: 40px;

        font-size: .95rem;

        line-height: 1.8;

        color: #666;
    }

    &__details {
        display: flex;
        flex-direction: column;

        gap: 25px;
    }

    &__detail {
        display: flex;
        flex-direction: column;

        gap: 5px;
    }

    &__detail-label {
        font-size: .95rem;
        font-weight: 600;

        letter-spacing: 1.8px;

        color: var(--primary);
    }

    &__detail a,
    &__detail p {
        font-size: .95rem;

        line-height: 1.6;

        color: var(--text);
    }

    &__detail a {
        transition: color .3s ease;

        &:hover {
            color: var(--primary);
        }
    }

    &__location {
        white-space: pre-line;
    }

    &__form-wrapper {
        width: 100%;
    }
}

@media (min-width: 768px) {
    .contact {
        padding: 110px 40px 120px;

        &__content {
            gap: 70px;
        }

        &__title {
            font-size: 3.5rem;
        }

        &__details {
            flex-direction: row;
            flex-wrap: wrap;

            gap: 35px;
        }

        &__detail {
            min-width: 160px;
        }
    }
}

@media (min-width: 1024px) {
    .contact {
        padding: 130px 40px 140px;

        &__content {
            display: grid;

            grid-template-columns: .85fr 1.15fr;

            align-items: start;

            gap: 100px;
        }

        &__intro {
            padding-top: 10px;
        }

        &__title {
            font-size: 4rem;
        }

        &__details {
            flex-direction: column;

            gap: 28px;
        }
    }
}

@media (min-width: 1400px) {
    .contact {

        &__content {
            grid-template-columns: .8fr 1.2fr;

            gap: 140px;
        }

        &__title {
            font-size: 4.5rem;
        }
    }
}
</style>